import {createAction} from '@reduxjs/toolkit';

export const setSelectedTab = createAction<'all' | 'unread'>('threads/actions/setSelectedTab');
